import React from "react";
import PacmanLoader from "react-spinners/PacmanLoader";
import SegmentEditor from "../SegmentEditor";
import SnapsWiseAudio from "./SnapsWiseAudio";
import SentencePracticeBlock from "./SentencePracticeBlock";
import PracticeControlsPanel from "./PracticeControlsPanel";
import IntonationComparisonPanel from "./IntonationComparisonPanel";
import AIAssessmentPanel from "./AIAssessmentPanel";

const PracticeModeView = ({
  audioref,
  fullaudio,
  timeUpdate,

  segments,
  editedSegments,
  editedSegment,
  setEditedSegments,
  setEditedSegment,

  segment,
  renderHelpPill,
  isMetadataNoHelp,
  setShowExerciseHelp,
  handlePreviousSegment,
  handleNextSegment,
  showCenterCue,
  practiceMode,
  echoingPhase,
  isCueActive,
  recordingStatus,
  cuePulseCount,
  echoingPulseCount,
  sentenceLabel,
  currentWord,
  handleWordPlay,
  openWordMenu,

  isgranted,
  getMicrophonePermission,
  isPlayingSegment,
  recordingProgress,
  handlePlayPause,
  handleMainAction,
  getButtonConfig,
  rate,
  setRate,

  loading,
  assessment,

  showIntonationVisualization,
  showIntonationHelp,
  setShowIntonationHelp,
  subject,
  file,
  handleLaneWordClick,
  broadcastTime,
  visualizationView,
  auth,
  resolvedAssessmentAudioUrl,
  resolvedNarratorAssessmentAudioUrl,

  canUsePronunciationApi,
  handleSaveEditedSegments,
}) => {
  return (
    <div className="flex-1 min-h-0 min-w-0 overflow-y-auto overflow-x-hidden p-4 xl:p-6 pb-6">
      <SnapsWiseAudio
        audioref={audioref}
        fullaudio={fullaudio}
        timeUpdate={timeUpdate}
      />

      {segments && !editedSegments && (
        <div className="flex flex-col gap-6">
          <SentencePracticeBlock
            segment={segment}
            segments={segments}
            renderHelpPill={renderHelpPill}
            isMetadataNoHelp={isMetadataNoHelp}
            setShowExerciseHelp={setShowExerciseHelp}
            handlePreviousSegment={handlePreviousSegment}
            handleNextSegment={handleNextSegment}
            showCenterCue={showCenterCue}
            practiceMode={practiceMode}
            echoingPhase={echoingPhase}
            isCueActive={isCueActive}
            recordingStatus={recordingStatus}
            cuePulseCount={cuePulseCount}
            echoingPulseCount={echoingPulseCount}
            sentenceLabel={sentenceLabel}
            currentWord={currentWord}
            handleWordPlay={handleWordPlay}
            openWordMenu={openWordMenu}
          />

          <PracticeControlsPanel
  isgranted={isgranted}
  getMicrophonePermission={getMicrophonePermission}
  practiceMode={practiceMode}
  recordingStatus={recordingStatus}
    recordingPhase={loading ? "processing" : recordingStatus === "recording" ? "recording" : "idle"}
  isPlayingSegment={isPlayingSegment}
  recordingProgress={recordingProgress}
  handlePlayPause={handlePlayPause}
  handleMainAction={handleMainAction}
  getButtonConfig={getButtonConfig}
  rate={rate}
  setRate={setRate}
  audioref={audioref}
  loading={loading}
/>

          

          <IntonationComparisonPanel
            showIntonationVisualization={showIntonationVisualization}
            showIntonationHelp={showIntonationHelp}
            setShowIntonationHelp={setShowIntonationHelp}
            segment={segment}
            assessment={assessment}
            subject={subject}
            file={file}
            handleLaneWordClick={handleLaneWordClick}
            broadcastTime={broadcastTime}
            audioref={audioref}
            visualizationView={visualizationView}
            rate={rate}
            setRate={setRate}
            auth={auth}
            resolvedAssessmentAudioUrl={resolvedAssessmentAudioUrl}
            resolvedNarratorAssessmentAudioUrl={resolvedNarratorAssessmentAudioUrl}
          />

          <AIAssessmentPanel
            assessment={assessment}
            canUsePronunciationApi={canUsePronunciationApi}
            segment={segment}
          />

          {auth?.role === "ADMIN" && segments && (
            <div className="flex justify-center">
              <button
                className="px-6 py-2 bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white rounded-lg transition-all duration-300 font-medium shadow-lg shadow-blue-500/25 hover:shadow-blue-500/40"
                onClick={() => {
                  const mysegments = [...segments];
                  const currentSegment = segments.find((s) => s.id === segment.id) || segments[0];
                  const mysegment = { ...currentSegment };
                  setEditedSegments(mysegments);
                  setEditedSegment(mysegment);
                }}
              >
                Edit Segments
              </button>
            </div>
          )}
        </div>
      )}

      {editedSegments && (
        <SegmentEditor
          segments={segments}
          editedSegments={editedSegments}
          setEditedSegments={setEditedSegments}
          editedSegment={editedSegment}
          setEditedSegment={setEditedSegment}
          audioref={audioref}
          subject={subject}
          file={file}
          onSave={handleSaveEditedSegments}
          onCancel={() => {
            setEditedSegments(null);
            setEditedSegment(null);
          }}
        />
      )}
    </div>
  );
};

export default PracticeModeView;